export const UPDATE_TIME_CARD_STATUS = `
  mutation ($id: ID!, $status: String!) {
    updateTimeCardStatus(timeCardStatus: {id: $id, status: $status}) {
      data 
      error {
        code
        message
        statusCode
      }
    }
  }
`
